import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=9af7b8be&scoped=true"
import script from "./Navigator.vue?vue&type=script&lang=js"
export * from "./Navigator.vue?vue&type=script&lang=js"
import style0 from "./Navigator.vue?vue&type=style&index=0&id=9af7b8be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af7b8be",
  null
  
)

export default component.exports